import React from "react";
import classes from "./styles.module.scss";

const ZeroButton = ({ onClick }: { onClick: () => void }) => (
  <button className={classes.zeroButton} onClick={onClick}>
    Zero
  </button>
);

export default ZeroButton;
